"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_keyby_1 = __importDefault(require("lodash.keyby"));
const lodash_reduce_1 = __importDefault(require("lodash.reduce"));
const keyRootById = object => {
    return (0, lodash_reduce_1.default)(object, (result, value, key) => {
        return { ...result, [key]: Array.isArray(value) ? (0, lodash_keyby_1.default)(value, 'id') : value };
    }, {});
};
exports.default = keyRootById;
